import { cookie } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/storage';
import { getParams } from '@cigna/cigna_digital_dcws_cigna-frontend/src/js/util/url'; // determine environment and which url to use

export var getAPIUrl = function getAPIUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.host;
  var postUrl;

  switch (url) {
    case 'pvs-campaigns.cigna.com':
      postUrl = 'https://v-apigateway0.cigna.com/v1/retail/web-lead/';
      break;

    case 'campaigns.cigna.com':
      postUrl = 'https://apigateway0.cigna.com/v1/retail/web-lead/';
      break;

    default:
      postUrl = 'https://s-apigateway0.cigna.com/v1/retail/web-lead/';
      break;
  }

  return postUrl;
};
export var prepData = function prepData() {
  var jsonData = {
    customerInformation: {},
    additionalInformation: {},
    identifiers: {}
  };
  var params = getParams();
  var sidField = document.getElementById('campaignSid');
  var cidField = document.getElementById('cid');
  var campaignId = cookie.get('acxiomdatach01') || getParams().utm_campaign;
  var mySid = [];
  if (campaignId) sidField.value = campaignId;

  if (params.cid) {
    cidField.value = params.cid;
    jsonData.identifiers.cid = params.cid;
  }

  if (params.afid) {
    jsonData.identifiers.vendorAffiliateId = params.afid;
  }

  if (!params.utm_campaign) {
    mySid.push(cookie.get('acxiomdatach01'));
  } else {
    mySid.push(getParams().utm_campaign);
  }

  jsonData.identifiers.campaignId = mySid;
  return jsonData;
};